import React from "react";

function GrowthDashboard() {
return ( <div className="executive-dashboard">
  <div className="executive-top">

    <div>
      <span className="dashboard-label">
        Executive Overview
      </span>

      <h3>
        Growth Command Center
      </h3>
    </div>

    <div className="dashboard-status">
      Active
    </div>

  </div>

  <div className="dashboard-hero-metric">
    <span>Pipeline Growth</span>

    <h2>+218%</h2>

    <p>
      Year-over-year improvement
    </p>
  </div>

  <div className="dashboard-insights">

    <div>
      <span>Marketing ROI</span>
      <strong>4.7x</strong>
    </div>

    <div>
      <span>Lead Quality</span>
      <strong>89%</strong>
    </div>

    <div>
      <span>Conversion Rate</span>
      <strong>+63%</strong>
    </div>

  </div>

</div>


);
}

export default GrowthDashboard;
